var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { classNames } from '@shapeable/utils';
import { ChevronLeftIconGlyph, ChevronRightIconGlyph } from '@shapeable/icons';
var cls = classNames('sidebar-button');
export var SidebarButtonDefaultProps = {
  isDisclosed: false,
  showDisclosureIcon: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    display: flex;\n    flex-direction: column;\n    padding: ", " ", ";\n    align-items: center;\n    text-transform: uppercase;\n    justify-content: center;\n    cursor: pointer;\n    width: 32px;\n    transition: all 0.5s;\n    ", ";\n\n    &:first-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    font-family: ", ";\n    font-weight: 500;\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    display: flex;\n    flex-direction: column;\n    padding: ", " ", ";\n    align-items: center;\n    text-transform: uppercase;\n    justify-content: center;\n    cursor: pointer;\n    width: 32px;\n    transition: all 0.5s;\n    ", ";\n\n    &:first-child {\n      background: none;\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), theme.FONT_SIZE(13), theme.COLOR('light'), theme.FILL('light'), theme.UNIT(4.5), theme.UNIT(1), theme.H_DOT_BG('light', 2, 6)),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(5), theme.UNIT(1))
});
var ImageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var DisclosureIconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(5))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    white-space: nowrap;\n    writing-mode: vertical-rl;\n  "], ["\n    white-space: nowrap;\n    writing-mode: vertical-rl;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Label: styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  DisclosureIcon: styled(Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DisclosureIconStyles)
};
export var SidebarButton = function (props) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    icon = props.icon,
    isDisclosed = props.isDisclosed,
    showDisclosureIcon = props.showDisclosureIcon;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, icon && React.createElement(My.Icon, null, icon), React.createElement(My.Label, null, children), showDisclosureIcon && React.createElement(My.DisclosureIcon, {
    size: 16
  }, isDisclosed ? React.createElement(ChevronRightIconGlyph, null) : React.createElement(ChevronLeftIconGlyph, null)));
};
SidebarButton.cls = cls;
SidebarButton.defaultProps = SidebarButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;